import {useIntl} from 'react-intl'
import clsx from 'clsx'

import {toAbsoluteUrl} from '@_metronic/helpers'
import {googleRedirect} from '@app/modules/auth/core/_requests'

import useReferralString from '@app/hooks/useReferralString'
import useIsMobileIOSCookieTrue from '@app/hooks/useIsMobileIOSCookieTrue'

import FormDivider from './FormDivider'

type GoogleLoginButtonProps = {
  className?: string
  loading: boolean
  error?: string
}
const GoogleLoginButton = ({className, loading, error}: GoogleLoginButtonProps) => {
  const ref_token = useReferralString()
  const intl = useIntl()
  const getGoogleRedirect = async (refToken: string | null) => {
    return refToken ? googleRedirect(refToken) : googleRedirect()
  }

  const hideGoogleLoginButton = useIsMobileIOSCookieTrue()

  const handleGoogleLogin = async () => {
    try {
      const {data} = await getGoogleRedirect(ref_token)
      window.location.href = data.value
    } catch (err) {
      console.error('Error during Google login: ', err)
    }
  }

  if (hideGoogleLoginButton) return null

  return (
    <>
      <div className={clsx('d-grid', className)}>
        <button
          type='button'
          id='kt_sign_in_google'
          className='btn border border-success text-success mt-3'
          onClick={handleGoogleLogin}
        >
          {!loading && (
            <div className='d-flex align-items-center justify-content-center'>
              <img
                alt='Google Logo'
                src={toAbsoluteUrl('/media/logos/google.svg')}
                style={{height: '12px'}}
              />
              <span className='indicator-label ms-2'>
                {intl.formatMessage({id: 'AUTH.GOOGLE'})}
              </span>{' '}
            </div>
          )}
          {loading && !error && (
            <span className='indicator-progress' style={{display: 'block'}}>
              {intl.formatMessage({id: 'ACTIONS.WAIT'})}
              <span className='spinner-border spinner-border-sm align-middle ms-2' />
            </span>
          )}
        </button>
      </div>

      <FormDivider text={intl.formatMessage({id: 'AUTH.WITH_EMAIL'})} />
    </>
  )
}

export default GoogleLoginButton
